import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export function counterRangeValidator(minValue, maxValue) {
  return (c: FormControl) => {
    const err = {
      rangeError: {
        given: c.value,
        min: minValue || 0,
        max: maxValue || 10,
      },
    };

    return c.value > +maxValue || c.value < +minValue ? err : null;
  };
}

@Component({
  selector: 'app-counter-input',
  templateUrl: './counter-input.component.html',
  styleUrls: ['./counter-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CounterInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CounterInputComponent),
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CounterInputComponent implements ControlValueAccessor, OnChanges {
  @Input('counterValue') counter = 0;
  @Input('max') counterRangeMax;
  @Input('min') counterRangeMin;
  @Input('index') index;
  @Output() valueChange = new EventEmitter<any>();
  @Output() showError = new EventEmitter<any>();
  constructor(private translateService: TranslateService) {}
  get counterValue() {
    return this.counter;
  }

  set counterValue(val) {
    this.counter = val;
    this.propagateChange(val);
    this.valueChange.emit(val);
  }

  propagateChange: any = () => {}; // Noop function
  validateFn: any = () => {}; // Noop function

  ngOnChanges(inputs) {
    if (inputs.counterRangeMax || inputs.counterRangeMin) {
      this.validateFn = counterRangeValidator(
        this.counterRangeMin,
        this.counterRangeMax
      );
    }
  }

  writeValue(value) {
    if (value) {
      this.counterValue = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  increase() {
    this.counterValue++;
    if (this.counterValue > 0)
      this.showError.emit({ message: undefined, index: this.index });
  }

  decrease() {
    if (this.counterValue != this.counterRangeMin) {
      this.counterValue--;
    } else {
      this.showError.emit({
        message:
          this.translateService.instant(
            'COPIES_NUMBER_SHOULD_BE_GREATER_THAN'
          ) + ' 0',
        index: this.index,
      });
      setTimeout(() => {
        this.showError.emit({ message: undefined, index: this.index });
      }, 2000);
    }
  }

  validate(c: FormControl) {
    return this.validateFn(c);
  }
}
